import React from 'react';
import PropTypes from 'prop-types';
import { getPriceBySlug } from 'shared/helpers/transportInfo';

import PriceUah from 'shared/components/PriceUah/PriceUah';
import {
  // isLeasingProposalAvailable,
  isCreditmarketProposalAvailable,
  isCreditmarketNotClearedProposalAvailable,
  // isUlf24LeasingProposalAvailable,
  isCommonLeasingProposalAvailable,
} from 'shared/helpers/leasing/myAuto';

import CreditMarketButton from 'shared/components/LeasingOnlineBanner/CreditMarketButton/CreditMarketButton';
import LeasingWithCalculatorButton from 'shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton';

class LeasingButtonWrapper extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    index: PropTypes.number,
    defaultButtonName: PropTypes.string,
    theme: PropTypes.string,
    eventPostfix: PropTypes.string,
  };

  static defaultProps = {
    index: 0,
    theme: 'yellow',
    defaultButtonName: '',
    eventPostfix: '',
  };

  checkDefaultButton(name) {
    const { defaultButtonName } = this.props;
    if (defaultButtonName === '') return true;
    return name === defaultButtonName;
  }

  renderComponent() {
    const { advert, theme } = this.props;
    const isCommonLeasingAvailable = isCommonLeasingProposalAvailable(advert);
    const isMyAutoOrHapaiAvailable = true; // isLeasingProposalAvailable(advert);
    // const isUlf24Available = false; isUlf24LeasingProposalAvailable(advert);
    const isCreditMarketAvailable = isCreditmarketProposalAvailable(advert);
    const isCreditmarketNotClearedAvailable = isCreditmarketNotClearedProposalAvailable(advert);

    if (isCommonLeasingAvailable) {
      // if (isUlf24Available && this.checkDefaultButton('LeasingUlfButton'))
      //   return <LeasingUlfButton {...this.props} />;

      if (isCreditMarketAvailable && this.checkDefaultButton('CreditMarketButton'))
        return <LeasingWithCalculatorButton {...this.props} />;
      // return <CreditMarketButton {...this.props} />;

      if (isCreditmarketNotClearedAvailable && this.checkDefaultButton('CreditMarketButton'))
        return <LeasingWithCalculatorButton {...this.props} isNotCleared />;
      // return <CreditMarketButton {...this.props} isNotCleared />;

      if (isMyAutoOrHapaiAvailable && this.checkDefaultButton('LeasingWithCalculatorButton'))
        return <LeasingWithCalculatorButton {...this.props} />;

      // if (isMyAutoOrHapaiAvailable && this.checkDefaultButton('LeasingButton'))
      //   return <LeasingButton {...this.props} />;
    }
    return <PriceUah uah={getPriceBySlug(advert.price, 'uah')} theme={theme} />;
  }

  render() {
    return (
      <React.Fragment>
        {this.renderComponent()}
      </React.Fragment>
    );
  }
}

export default LeasingButtonWrapper;



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/LeasingButtonWrapper/LeasingButtonWrapper.js